// extracted by mini-css-extract-plugin
export default {"wrapper":"Loader_wrapper__ZuzTv","loader":"Loader_loader__Ji4D0","blink":"Loader_blink__w574r"};